import Lottie from 'lottie-react';
import animationData from './pre_loader.json';
import styles from './Preloader.module.scss';

const Preloader = ({}) => {
    
    return <div className={styles.preloader}>
        <Lottie 
            animationData={animationData} 
            loop={true} 
            autoplay={true}
        />
    </div>;
};
  
export default Preloader;